import CustomBarChart from "../../../../Common/Components/Charts/BarChart";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CircularProgress from "../../../../Common/Components/CircularLoader";
import axiosMain from "../../../../http/axiosMain";
import SelectPopover from "../../../../Common/Components/SelectPopover";

const getContentPostedData = (data) => {
  return [
    {
      name: "Shorts",
      value: data?.shorts || 0,
      fill: "#D0FCD7",
    },
    {
      name: "Videos",
      value: data?.videos || 0,
      fill: "#C3E9F8",
    },
    {
      name: "Live Streams",
      value: data?.liveStreams,
      fill: "#F8B4BD",
    },
  ];
};

const ContentPosted = ({ campaigns, loading }) => {
  const [contentPostedLoading, setContentPostedLoading] = useState(true);
  const [contentPostedInsights, setContentPostedInsights] = useState({});
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  const getYoutubeContentPosted = async (campaignDetails) => {
    try {
      setContentPostedLoading(true);
      const resp = await axiosMain.get(
        `api/v1/insights/youtube-content-posted/${campaignDetails.campaign_id}`
      );
      if (resp.status === 200 && resp.data?.success) {
        setContentPostedInsights(resp.data?.data || {});
      } else {
        toast.error(resp.data?.message || "Something went wrong", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || err?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    } finally {
      setContentPostedLoading(false);
    }
  };

  useEffect(() => {
    if (selectedCampaign?.campaign_id)
      getYoutubeContentPosted(selectedCampaign);
  }, [selectedCampaign]);

  useEffect(() => {
    if (campaigns.length) setSelectedCampaign(campaigns[0]);
  }, [campaigns]);

  useEffect(() => {
    if (!loading) {
      if (campaigns.length) setSelectedCampaign(campaigns[0]);
      else {
        setContentPostedLoading(false);
      }
    }
  }, [campaigns, loading]);

  return (
    <div className="youtube-container">
      <div className="options-content">
        <span className="platformtitle card-title">Content Posted</span>
        {campaigns.length ? (
          <SelectPopover
            options={campaigns
              .filter((i) => i.campaign_title)
              .map((i) => ({ ...i, label: i.campaign_title }))}
            onChange={(value) => {
              setSelectedCampaign(value);
            }}
          >
            <div className="right-top-actions">
              <span>{selectedCampaign?.campaign_title}</span>
              <ExpandMoreRoundedIcon sx={{ width: "20px" }} />
            </div>
          </SelectPopover>
        ) : (
          <></>
        )}
      </div>
      <div style={{ marginTop: "8px" }}>
        {!contentPostedLoading && Object.keys(contentPostedInsights).length ? (
          <>
            <CustomBarChart
              data={getContentPostedData(contentPostedInsights)}
              width={700}
              height={332}
            />
          </>
        ) : contentPostedLoading || loading ? (
          <CircularProgress
            containerStyle={{
              minHeight: "332px",
            }}
          />
        ) : (
          <div className="no-data">
            <small>No Data Found.</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentPosted;
